import React, { useContext } from "react";
import _ from "lodash";
import { Edit } from "react-admin";
import { getSchoolNameFromGame } from "games/utils";
import GameEditFootball from "./GameEditFootball";
import GameEditSport from "./GameEditSport";
import CircularProgress from "@material-ui/core/CircularProgress";
import { PlayByPlayContextProvider } from "games/model/PlayByPlayContext";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";
import { isDisplayable } from "util/misc";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  title: {
    fontSize: "20px"
  }
});

/*
 * There is a different admin for football vs other sports
 * Football includes the play by play interface that is optimized for stringers to use.
 * Plays and stats data is stored under "playsblob" as a stringified object. Data is also retrieved from the playsblob on initial page load.
 * This makes data easier to handle when internet is spotty, which is a use case for stringers reporting live games.
 * For other (not football) sports, data is saved to the playsblob but not retrieved from the playsblob
 * It is less custom and more the "react-admin" way.
 */
const Switcher = (props) => {
  const {
    usePlayByPlay: [state]
  } = useContext(PlayByPlayContext);
  const sportCode = _.get(props, "record.sportCode");

  if (!isDisplayable(_.get(state, "game"))) {
    return <CircularProgress />;
  } else if (sportCode === "football") {
    return <GameEditFootball {...props} />;
  } else {
    return <GameEditSport {...props} />;
  }
};

const GameTitle = ({ record }) => {
  const classes = useStyles();
  const { sportCode } = record;
  const homeSchoolName = getSchoolNameFromGame(record, "home");
  const awaySchoolName = getSchoolNameFromGame(record, "away");
  const title = `${awaySchoolName} vs ${homeSchoolName} | ${sportCode}`;
  return <h1 className={classes.title}>{title}</h1>;
};

/*
 * Wrapper component so that the record could be passed into the PlayByPlayContextProvider.
 * The record is not accessable directly in the GameEdit component.
 */
const GameEditInner = (props) => {
  return (
    <PlayByPlayContextProvider game={props.record}>
      <GameTitle record={props.record} />
      <Switcher {...props} />
    </PlayByPlayContextProvider>
  );
};

const GameEdit = (props) => {
  return (
    <Edit component="div" undoable={false} {...props}>
      <GameEditInner />
    </Edit>
  );
};

export default GameEdit;
